import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "../../styles";

interface Props {
  isHide: boolean;
}
interface ContainerProps {
  isHide: boolean;
}

const BannerContainer = styled.div<ContainerProps>`
  width: 94%;
  // background: linear-gradient(254.71deg, rgba(${colors.gradDark}) 1.92%, rgba(${colors.gradLight}) 101.29%);
  // background: #0C2340;
  // border: 2px solid rgba(${colors.border});
  margin: 0 auto;
  border-radius: 25px;
  padding: 2em;
  backdrop-filter: blur(4px);
  margin-top: ${(props) => (props.isHide ? 0 : "250px")};
  transition: all 0.2s ease-in-out;
`;
const SaleTitle = styled.h3`
  font-size: 40px;
  color: white;
  text-align: center;
  font-family: "Montserrat-SemiBold";
`;
const Description = styled.h5`
  font-size: 22px;
  color: #fafafa;
  opacity: 0.7;
  margin: 2.5em 0;
  text-align: center;
`;

const SaleTopContainer: React.FC<Props> = ({ isHide }) => {
  const { t } = useTranslation();
  return (
    <BannerContainer isHide={isHide}>
      <SaleTitle>{t("PublicSaleTitle")}</SaleTitle>
      <Description>{t("PublicSaleDesc1")}</Description>
      <Description>{t("PublicSaleDesc2")}</Description>
      <Description style={{ color: "#18FA3C" }}>
        {t("PublicSaleDesc3")}
      </Description>
    </BannerContainer>
  );
};

export default SaleTopContainer;
